//Built-in libraries

//Third party libraries

//Custom components
import Button from '@/components/UI/Button';
import { HookInput } from '@/components/UI/HookForm/Form/Input';
import HookMaskedInput from '@/components/UI/HookForm/Form/MaskedInput';
import { HookRadioGroup } from '@/components/UI/HookForm/Form/RadioGroup';
import { HookSelect } from '@/components/UI/HookForm/Form/Select';
//Services
import { useApplicationFormContext } from '@/features/ApplicationForm/ApplicationFormProvider';

//STP Libraries

//Assets and Miscellaneous
import { States } from '../../../../../../constants';
import { gender, maritalStatus, neighborhoods, races } from './constants';

//Component Begin

export default function Application() {
  const { setCurrentStep } = useApplicationFormContext();

  return (
    <div className='p-6 space-y-6 sm:rounded-r-md sm:overflow-hidden'>
      <div>
        <h3 className='text-lg leading-6 font-medium text-primaryColor-normal'>Application Information</h3>
      </div>
      <div className='grid grid-cols-6 gap-6'>
        <HookInput customClassName='col-span-2' label='Name' name='application.name' type='text' />
        <HookInput customClassName='col-span-6 sm:col-span-3 lg:col-span-2' label='Date of Birth' name='application.dob' type='date' />
        <HookMaskedInput customClassName='col-span-2' label='Phone' name='application.phone' maskedComponent='phone' />
        <HookInput customClassName='col-span-4' label='Current Address' name='application.streetAddress' type='text' />
        <HookInput customClassName='col-span-6 sm:col-span-6 lg:col-span-2' label='City' name='application.city' type='text' disabled />
        <HookSelect
          customClassName='col-span-6 sm:col-span-3 lg:col-span-2'
          label='State'
          name='application.state'
          options={States.map((s) => ({
            label: s.name,
            value: s.name,
          }))}
          disabled
        />
        <HookMaskedInput
          customClassName='col-span-6 sm:col-span-3 lg:col-span-2'
          label='Zip / Postal Code'
          name='application.zipCode'
          maskedComponent='zipCode'
        />
        <HookSelect
          customClassName='col-span-6 sm:col-span-3 lg:col-span-2'
          label='Neighborhood'
          name='application.neighborhood'
          options={neighborhoods.map((n) => ({ label: n, value: n }))}
        />
        <HookRadioGroup
          className='col-span-6'
          label='Is Female Head of Household?'
          name='application.femaleHeadOfHousehold'
          id='application.femaleHeadOfHousehold'
          options={[
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' },
          ]}
        />
        <HookRadioGroup
          className='col-span-6'
          label='Was the house built before 1978?'
          name='application.wasBuiltBefore1978'
          id='application.wasBuiltBefore1978'
          options={[
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' },
          ]}
        />
        <HookRadioGroup
          className='col-span-6'
          label='Flood Insurance Required & Requested?'
          name='application.requestedInsurance'
          id='application.requestedInsurance'
          options={[
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' },
          ]}
        />
        <HookRadioGroup
          className='col-span-6'
          label='Do children less than 6 years old live/spend substantial time in this house?'
          name='application.doChildrenLive'
          id='application.doChildrenLive'
          options={[
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' },
          ]}
        />
        <HookRadioGroup
          className='col-span-6'
          label='Gender'
          name='application.gender'
          id='application.gender'
          options={gender.map((d) => {
            return { label: d, value: d };
          })}
        />
        <HookRadioGroup
          className='col-span-6'
          label='Marital Status'
          name='application.maritalStatus'
          id='application.maritalStatus'
          options={maritalStatus.map((d) => {
            return { label: d, value: d };
          })}
        />
        <HookRadioGroup
          className='col-span-6'
          label='Disabled'
          name='application.disabled'
          id='application.disabled'
          options={[
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' },
          ]}
        />
        <HookRadioGroup
          className='col-span-6'
          label='Do you have $5,000+ in Assets?'
          name='application.hasAssets'
          id='application.hasAssets'
          options={[
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' },
          ]}
        />
        <HookRadioGroup
          className='col-span-6'
          label='Received assistance in 3 years'
          name='application.receivedAssistance'
          id='application.receivedAssistance'
          options={[
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' },
          ]}
        />
        <HookSelect
          customClassName='col-span-6 sm:col-span-3 lg:col-span-2'
          label='Race'
          name='application.race'
          options={races.map((p) => ({
            label: p,
            value: p,
          }))}
        />
      </div>
      <div className='flex gap-4 justify-end mt-5'>
        <Button label='Previous' btnStyle='neutral' type='button' onClick={() => setCurrentStep((prev) => prev - 1)} />
        <Button label='Next' btnStyle='primary' type='submit' />
      </div>
    </div>
  );
}
